import styled from 'styled-components';

export const Link = styled.a`
  color: '#BA1B1A';

  :hover {
    text-decoration: underline;
  }
`;
